<!--
 * @Author: pyy
 * @Date: 2022-09-16
 * @Description: 县区统计-折柱图
-->
<template>
	<div class="line-bar-chart h100 pdt10">
		<div ref="myChart"
			 style="width: 100%; height: 100%"></div>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import * as API from '@/api/FormManager/FormManager'
import { mapState } from 'vuex'
import { html2canvasExport } from '@/utils/tools'

export default {
	props: {
		apiParams: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			chart: null,
			options: {
				color: ['#6666ff', '#66cc99', '#ff6600', '#ffcc33'],
				legend: {
					textStyle: {
						fontSize: 12,
						color: '#888',
					},
					top: '5',
				},
				grid: {
					left: '3%',
					right: '3%',
					top: '80',
					bottom: '40',
					containLabel: true,
				},
				tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255, 255, 255, 1)',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985',
						},
					},
					padding: [5, 10, 5, 10],
					formatter: function (params) {
						return (
							params[0].axisValue +
							`<br>` +
							params
								.map((item) => {
									let str = `<span style="display:inline-block;width:20px;height:12px;margin: 0 8px 0 -3px;border-radius:2px;background-color:${item.color};"></span>`
									if (item.componentSubType === 'line') {
										str = `<span style="display:inline-block; width: 5px;height: 2px; margin: 0 -5px 5px -3px;background-color: ${item.color}"></span>
											   <span style="display:inline-block; width:12px;height:12px; border-radius:50%;border: 2px solid ${item.color};"></span>
											   <span style="display:inline-block; width: 5px;height: 2px; margin: 0 7px 5px -5px;background-color: ${item.color}"></span>`
									}
									let seriesNameStr = `<span style="display:inline-block;">${item.seriesName}</span>`
									let value = item.value[item.encode.y[0]]
									let valueStr = `<span style="display:inline-block;margin-left:20px;font-weight: bold">${value}</span>`
									return `<span style="display:flex; justify-content:space-between; margin-bottom: 2px">
												<span>${str}${seriesNameStr}</span>
												<span>${valueStr}</span>
											</span>`
								})
								.join(``)
						)
					},
				},
				xAxis: { type: 'category' },
				yAxis: {
					type: 'value',
					axisLabel: {
						formatter: '{value} 万元',
					},
				},
				series: [
					{ type: 'bar', datasetIndex: 0, barWidth: 19 },
					{ type: 'bar', datasetIndex: 0, barWidth: 19 },
					{ type: 'bar', datasetIndex: 0, barWidth: 19 },
					{ type: 'bar', datasetIndex: 0, barWidth: 19 },
					{ type: 'line', datasetIndex: 1, smooth: true },
					{ type: 'line', datasetIndex: 1, smooth: true },
					{ type: 'line', datasetIndex: 1, smooth: true },
					{ type: 'line', datasetIndex: 1, smooth: true },
				],
				dataset: [
					{
						source: [
							[
								'product',
								'片区当月总计划完成产值',
								'片区当月总申报完成产值',
								'片区当月总审核完成产值',
								'片区当月总实际付款',
							],
							// ['1月', 43.3, 85.8, 93.7, 100],
							// ['2月', 53.1, 63.4, 55.1, 60],
							// ['3月', 69.1, 73.4, 65.1, 80],
							// ['4月', 83.1, 93.2, 85.5, 90],
							// ['5月', 43.3, 85.8, 93.7, 100],
							// ['6月', 53.1, 63.4, 55.1, 60],
							// ['7月', 69.1, 73.4, 65.1, 80],
							// ['8月', 83.1, 93.2, 85.5, 90],
						],
					},
					{
						source: [
							[
								'product',
								'片区累计总计划完成产值',
								'片区累计总申报完成产值',
								'片区累计总审核完成产值',
								'片区累计总实际付款',
							],
							// ['1月', 43.3, 85.8, 93.7, 100],
							// ['2月', 53.1, 63.4, 55.1, 60],
							// ['3月', 69.1, 73.4, 65.1, 80],
							// ['4月', 83.1, 93.2, 85.5, 90],
							// ['5月', 43.3, 85.8, 93.7, 100],
							// ['6月', 53.1, 63.4, 55.1, 60],
							// ['7月', 69.1, 73.4, 65.1, 80],
							// ['8月', 83.1, 93.2, 85.5, 90],
						],
					},
				],
			},
		}
	},
	created() {},
	mounted() {
		window.addEventListener('resize', () => {
			setTimeout(() => {
				if (!!this.chart) {
					this.chart.resize()
				}
			}, 300)
		})
	},
	methods: {
		_getData() {
			const params = {
				...this.apiParams,
				isNorth:
					this.apiParams.isNorth.indexOf(',') > -1
						? ''
						: this.apiParams.isNorth,
			}
			API.getCityStatisticsToFoldColumnDiagram(params).then((res) => {
				if (!!res.data && res.data.length > 0) {
					const barData = res.data.map((item) => {
						const {
							mon = '',
							plan = '0',
							declare = '0',
							examine = '0',
							actual = '0',
						} = item
						return [mon, plan, declare, examine, actual]
					})
					const lineData = res.data.map((item) => {
						const {
							mon = '',
							planTotal = '0',
							declareTotal = '0',
							examineTotal = '0',
							actualTotal = '0',
						} = item
						return [
							mon,
							planTotal,
							declareTotal,
							examineTotal,
							actualTotal,
						]
					})

					const obj = this.projectDict.xmgsqy.find(
						(item) => item.value === this.apiParams.isNorth
					)

					const areaName =
						!!obj && obj.sname ? obj.sname + '当月' : '片区当月总'
					const areaName2 =
						!!obj && obj.sname ? obj.sname + '累计' : '片区累计总'

					this.options.dataset[0].source = [
						[
							'product',
							areaName + '计划完成产值',
							areaName + '申报完成产值',
							areaName + '审核完成产值',
							areaName + '实际付款',
						],
						...barData,
					]
					this.options.dataset[1].source = [
						[
							'product',
							areaName2 + '计划完成产值',
							areaName2 + '申报完成产值',
							areaName2 + '审核完成产值',
							areaName2 + '实际付款',
						],
						...lineData,
					]

					setTimeout(() => {
						this.initChart()
					}, 200)
				}
			})
		},

		initChart() {
			this.chart = echarts.init(this.$refs.myChart)
			this.chart.setOption(this.options, true)
		},

		download(fileName) {
			if (this.$refs.myChart) {
				html2canvasExport(this.$refs.myChart, fileName)
			}
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
	},
	watch: {
		apiParams: {
			handler(newVal) {
				if (newVal.unit == 0) {
					this.options.yAxis.axisLabel = {
						formatter: '{value} 元',
					}
				} else if (newVal.unit == 1) {
					this.options.yAxis.axisLabel = {
						formatter: '{value} 万元',
					}
				}

				this._getData()
			},
			deep: true,
		},
	},
}
</script>

<style>
</style>